import type { HistoryEventType } from "~/graphql/supergraphTypes";

export const getTextForHistoryEvent = (
  eventType: HistoryEventType,
  changedByName: string | null | undefined,
): string => {
  const byName = changedByName ? ` by ${changedByName}` : "";

  switch (eventType) {
    case "CREATED":
      return `Case created${byName}`;
    case "SUBMITTED":
      return `Submitted for review${byName}`;
    case "APPROVED":
      return `Case approved${byName}`;
    // GP EUM cases store their negative terminal as REJECTED; product copy is "Invalid".
    case "REJECTED":
    case "INVALID":
      return `Case marked invalid${byName}`;
    case "FEEDER_FUNDS_ADDED":
      return `Entities added${byName}`;
    case "FEEDER_FUNDS_REMOVED":
      return `Entities removed${byName}`;
    case "ENTITY_REMOVED_FROM_DW":
      return "Entity removed from data warehouse";
    case "RENAMED":
      return `Billing group renamed${byName}`;
    case "REVIEWER_APPROVED":
      return `Reviewer approved${byName}`;
    case "REVIEWER_REJECTED":
      return `Reviewer rejected${byName}`;
    // System event — the reviewer took no action, so it is never attributed.
    case "REVIEWER_AUTO_APPROVED":
      return "CSM approval auto-completed";
    default:
      return `Event${byName}`;
  }
};
